import type { AREA_PATH_TYPE } from 'src/types/area';

export const KaimonoWebRoutes = {
  agreements: {
    userAgreement: '/agreements/tax-free-shop/'
  },
  products: {
    show: (productId: number) => `/products/${productId}`
  },
  makers: {
    list: `/makers/`,
    show: (makerId: number) => `/makers/${makerId}`
  },
  largeCategories: {
    show: (largeCategorySlug: string) => `/large_categories/${largeCategorySlug}`
  },
  middleCategories: {
    show: (middleCategorySlug: string) => `/middle_categories/${middleCategorySlug}`
  },
  smallCategories: {
    show: (smallCategorySlug: string) => `/small_categories/${smallCategorySlug}`,
    showWithBrandSlug: (smallCategorySlug: string, brandSlug: string) =>
      `/small_categories/${smallCategorySlug}?brand=${brandSlug}`
  },
  tinyCategories: {
    show: (tinyCategorySlug: string) => `/tiny_categories/${tinyCategorySlug}`
  },
  springFes2020: '/spring_fes_2020',
  valentine2020: '/valentine_2020',
  sakura2020: '/sakura_2020',

  featured: {
    /**
     * リンク先がmiddle/large categoryでない専用ページ
     */
    show: (featureTagSlug: string) => `/featured/${featureTagSlug}`,
    index: `/featured`,
    popular: `/featured/popular`,
    snacks_set: '/featured/snacks_set',
    snacks: '/featured/snacks',
    skin_whiten: '/featured/skin_whiten',
    anti_aging: '/featured/anti_aging',
    sensitive_skin: '/featured/sensitive_skin',
    collagen: '/featured/collagen',
    drug_store: '/featured/drug_store',
    nrt: '/featured/nrt',
    hnd: '/featured/hnd',
    oka: '/featured/oka',
    cts: '/featured/cts',
    ngo: '/featured/ngo',
    kix: '/featured/kix',
    sdj: '/featured/sdj',
    fuk: '/featured/fuk',
    '2021sale': '/featured/2021sale',
    omiyage: '/featured/omiyage',
    quickship: '/featured/quickship',
    limited_sale: '/featured/limited_sale',
    meijiPowderMilk: '/featured/meiji_powder_milk',
    dhc_supplements: '/featured/dhc_supplements',
    matcha: '/featured/matcha',
    popular_baby_products: '/featured/popular_baby_products'
  },

  special_offer: {
    kose_buyer: '/special_offer/kose_buyer'
  },

  favorites: {
    index: '/favorites'
  },

  ranking: {
    index: '/ranking'
  },
  recommended: '/recommended',

  // static routes that map to src/pages
  index: '/',
  brands: {
    list: '/brands',
    show: (brandId: number) => `/brands/${brandId}`
  },
  recommendedCosmetics: '/recommended_cosmetics',
  recommendedSnacks: '/recommended_snacks',
  walkthrough: '/walkthrough',
  taxfreeGuide: '/taxfree_guide',

  shops: {
    OBSOLETE_index: '/shops',
    show: (shopSlug: string) => {
      return `/shops/${shopSlug}`;
    }
  },

  search: (searchInput: string) => `/search/?i=${encodeURIComponent(searchInput)}`,
  searchRoot: `/search`,
  order: {
    new: '/order/new',
    payment: `/order/payment`,
    complete: (orderId = '') => {
      if (orderId) {
        return `/order/complete/?order_id=${orderId}`;
      }
      // 以下は実際は使わないが、Meta情報に含めるために書いている
      return `/order/complete/`;
    },
    show: (orderId: string) => `/order/show/?order_id=${orderId}`,
    secondPayment: (orderId: string, code: string) => `/order/secondPayment/?order_id=${orderId}&code=${code}`
  },
  cart: '/cart',
  guide: '/guide',
  pickupSupport: '/pickup_support',
  customerSupport: '/support',
  campaign: {
    referral: '/campaign/202304_referral',
    esun: '/campaign/esunbank202401',
    ubot: '/campaign/ubot202407',
    yuanta: '/campaign/yuantabank202409',
    esunForApp: '/campaign/esunbank202401_app',
    yuantaForApp: '/campaign/yuantabank202409-app'
  },
  localSouvenirs: {
    index: '/local-souvenirs',
    area: (area: AREA_PATH_TYPE) => `/local-souvenirs/area/${area}`
  },
  campaignFancl: '/campaign-fancl',
  campaignPrimavista: '/brands/251',
  japaneseSake: '/japanese-sake',
  couponList: '/coupon-list',
  bake: '/brands/1746',
  lp: {
    mediaCoupon: '/lp/media-coupon',
    antiUVCosmetics: '/lp/anti-uv-cosmetics',
    serviceIntroductionSnowPage: 'lp/service-introduction-snow'
  }
} as const;

/**
 * Waの別のWebサービス
 * - 飛ぶときは location.href = URL の形で
 */
export const WaWebRoutes = {
  account: {
    me: {
      payment: `/account/me/payment`,
      mypage: `/account/me/orders`,
      coupons: `/account/me/coupons`
    }
  },
  insurance: '/insurance',
  activity: '/activity',
  snow: '/snow'
} as const;
